import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import { SalesExecutiveContext, CommonContext } from './../../contexts/constant/ActionTypes';
import SalesExecutive from '../../components/SalesExecutive/SalesExecutive';

const SalesExecutivePage = ({history, match}) => {
    const salesexecutiveContext = useContext(SalesExecutiveContext);
    const commonContext = useContext(CommonContext);

	return (
    <div>
        <SalesExecutive
            history={history} 
            match={match}
            salesexecutiveContext={salesexecutiveContext}
            commonContext={commonContext}
        />
    </div>
	);
}

SalesExecutivePage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

SalesExecutivePage.defaultProps = {
    history: {},
    match: {}
};

export default SalesExecutivePage;



// WEBPACK FOOTER //
// ./containers/SalesExecutivePage/SalesExecutivePage.js